export const translations = {
  en: {
    nav: {
      services: "Services",
      about: "About",
      contact: "Contact",
      demo: "Request Demo",
      viewAllServices: "View All Services"
    },
    hero: {
      title: "Next-Gen iGaming Solutions",
      subtitle: "Powering the future of online gaming with seamless aggregation, cutting-edge platforms, and secure payment processing.",
      cta: "Get Started",
      stats: {
        games: "Games",
        providers: "Providers",
        markets: "Markets",
        uptime: "Uptime"
      }
    },
    services: {
      label: "What We Offer",
      title: "Our Services",
      aggregator: {
        title: "iGaming Aggregator",
        desc: "Access 10,000+ games from 100+ providers through a single API integration."
      },
      platform: {
        title: "iGaming Platform",
        desc: "Turnkey white-label solutions with full customization and rapid deployment."
      },
      payments: {
        title: "iGaming Payments",
        desc: "Multi-currency payment processing with 99.9% uptime guarantee."
      },
      crypto: {
        title: "Crypto Payments",
        desc: "Accept BTC, ETH, USDT and 50+ cryptocurrencies instantly."
      }
    },
    about: {
      label: "About Us",
      title: "About SoftMaya",
      description1: "Founded in 2016, SoftMaya has grown into a leading technology provider within the iGaming industry, delivering end-to-end solutions designed for scalability, performance, and global reach.",
      description2: "From the very beginning, our focus has been on building robust infrastructure and simplifying complex operations for operators. Over the years, we have continuously expanded our ecosystem, adapting to industry demands and technological advancements.",
      ourJourney: "Our Journey",
      today: "Today",
      todayDesc: "SoftMaya operates as a comprehensive technology partner for iGaming businesses, offering:",
      todayFooter: "Our solutions are designed to provide seamless user experiences, operational efficiency, and the flexibility required to operate across multiple jurisdictions.",
      ourVision: "Our Vision",
      visionDesc: "To build the next generation of iGaming infrastructure by delivering innovative, reliable, and future-ready technology solutions that empower operators worldwide.",
      milestones: {
        year2016: { title: "Game Aggregation", desc: "SoftMaya was established with a strong focus on game aggregation, providing operators with seamless access to multiple game providers through a single integration." },
        year2019: { title: "iGaming Platform Solutions", desc: "We introduced our full iGaming platform, offering a complete operational environment including player management, back-office tools, and scalable system architecture." },
        year2020: { title: "iGaming Payment Solutions", desc: "We developed advanced payment solutions tailored specifically for the iGaming sector, enabling fast, secure, and localized transactions across various markets." },
        year2022: { title: "Crypto Payment Solutions", desc: "Expanding into digital finance, we integrated crypto payment systems, allowing operators to support modern payment methods with high efficiency and flexibility." },
        year2023: { title: "Campaign, Promotion & Jackpot Systems", desc: "We launched advanced engagement tools, including campaign management systems, promotional engines, and dynamic jackpot solutions to enhance player retention and monetization." },
        year2024: { title: "New Provider Partnerships", desc: "SoftMaya expanded its game aggregation portfolio through new agreements with game providers." },
        year2025: { title: "Gaming Platform Upgrade", desc: "SoftMaya released an updated version of its gaming platform." },
        year2026: { title: "Launch of Own Gaming Operations", desc: "SoftMaya began its own gaming operations, expanding its activities alongside its technology and aggregation services." }
      },
      services: {
        platform: "iGaming Platform Infrastructure",
        aggregation: "Game Aggregation Solutions",
        localization: "Localization & Access Optimization Technologies",
        payments: "Payment & Crypto Payment Systems",
        campaigns: "Campaign, Bonus & Jackpot Engines",
        api: "API-driven Integrations for scalable operations"
      }
    },
    slotMachine: {
      badge: "Try Before You Buy",
      title1: "Experience Our",
      title2: "Gaming Tech",
      description: "Get a taste of our platform quality with this mini slot demo. Our full platform features",
      games: "10,000+ games",
      descEnd: ", seamless integrations, and enterprise-grade reliability.",
      requestDemo: "Request Full Demo",
      exploreGames: "Explore 10K+ Games",
      statsGames: "Games Available",
      statsProviders: "Game Providers",
      statsUptime: "Uptime"
    },
    contact: {
      title: "Get in Touch",
      contactTab: "Contact Us",
      demoTab: "Request Demo",
      name: "Full Name",
      email: "Email Address",
      company: "Company Name",
      phone: "Phone Number",
      message: "Your Message",
      services: "Services of Interest",
      submit: "Send Message",
      submitDemo: "Request Demo",
      success: "Message sent successfully!",
      demoSuccess: "Demo request submitted!"
    },
    footer: {
      tagline: "Powering the future of iGaming",
      services: "Services",
      company: "Company",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      aml: "AML Policy",
      copyright: "© 2024 SOFTMAYA GAMING. All rights reserved."
    }
  },
  tr: {
    nav: {
      services: "Hizmetler",
      about: "Hakkımızda",
      contact: "İletişim",
      demo: "Demo Talep Et",
      viewAllServices: "Tüm Hizmetleri Gör"
    },
    hero: {
      title: "Yeni Nesil iGaming Çözümleri",
      subtitle: "Kesintisiz agregasyon, son teknoloji platformlar ve güvenli ödeme işleme ile online oyun geleceğini güçlendiriyoruz.",
      cta: "Başlayın",
      stats: {
        games: "Oyun",
        providers: "Sağlayıcı",
        markets: "Pazar",
        uptime: "Uptime"
      }
    },
    services: {
      label: "Neler Sunuyoruz",
      title: "Hizmetlerimiz",
      aggregator: {
        title: "iGaming Aggregator",
        desc: "Tek API entegrasyonu ile 100+ sağlayıcıdan 10.000+ oyuna erişin."
      },
      platform: {
        title: "iGaming Platform",
        desc: "Tam özelleştirme ve hızlı dağıtım ile anahtar teslim white-label çözümleri."
      },
      payments: {
        title: "iGaming Payments",
        desc: "%99.9 uptime garantisi ile çoklu para birimi ödeme işleme."
      },
      crypto: {
        title: "Crypto Payments",
        desc: "BTC, ETH, USDT ve 50+ kripto para birimini anında kabul edin."
      }
    },
    about: {
      label: "Hakkımızda",
      title: "SoftMaya Hakkında",
      description1: "2016 yılında kurulan SoftMaya, ölçeklenebilirlik, performans ve küresel erişim için tasarlanmış uçtan uca çözümler sunarak iGaming sektöründe lider bir teknoloji sağlayıcısına dönüştü.",
      description2: "Başından beri odak noktamız, sağlam altyapı inşa etmek ve operatörler için karmaşık operasyonları basitleştirmek olmuştur. Yıllar içinde, sektör taleplerine ve teknolojik gelişmelere uyum sağlayarak ekosistemimizi sürekli genişlettik.",
      ourJourney: "Yolculuğumuz",
      today: "Bugün",
      todayDesc: "SoftMaya, iGaming işletmeleri için kapsamlı bir teknoloji ortağı olarak çalışmaktadır:",
      todayFooter: "Çözümlerimiz, birden fazla yargı alanında faaliyet göstermek için gereken kesintisiz kullanıcı deneyimleri, operasyonel verimlilik ve esnekliği sağlamak üzere tasarlanmıştır.",
      ourVision: "Vizyonumuz",
      visionDesc: "Dünya çapındaki operatörleri güçlendiren yenilikçi, güvenilir ve geleceğe hazır teknoloji çözümleri sunarak yeni nesil iGaming altyapısını inşa etmek.",
      milestones: {
        year2016: { title: "Oyun Agregasyonu", desc: "SoftMaya, tek bir entegrasyon ile birden fazla oyun sağlayıcısına erişim sağlayan oyun agregasyonuna odaklanarak kuruldu." },
        year2019: { title: "iGaming Platform Çözümleri", desc: "Oyuncu yönetimi, back-office araçları ve ölçeklenebilir sistem mimarisi dahil tam iGaming platformumuzu tanıttık." },
        year2020: { title: "iGaming Ödeme Çözümleri", desc: "iGaming sektörü için özel olarak tasarlanmış, çeşitli pazarlarda hızlı, güvenli ve yerelleştirilmiş işlemler sağlayan gelişmiş ödeme çözümleri geliştirdik." },
        year2022: { title: "Kripto Ödeme Çözümleri", desc: "Dijital finansa genişleyerek, operatörlerin yüksek verimlilik ve esneklikle modern ödeme yöntemlerini desteklemesini sağlayan kripto ödeme sistemlerini entegre ettik." },
        year2023: { title: "Kampanya, Promosyon & Jackpot Sistemleri", desc: "Oyuncu tutma ve monetizasyonu artırmak için kampanya yönetim sistemleri, promosyon motorları ve dinamik jackpot çözümleri dahil gelişmiş etkileşim araçlarını başlattık." },
        year2024: { title: "Yeni Sağlayıcı Ortaklıkları", desc: "SoftMaya, oyun sağlayıcılarıyla yaptığı yeni anlaşmalarla oyun agregasyon portföyünü genişletti." },
        year2025: { title: "Oyun Platformu Güncellemesi", desc: "SoftMaya, oyun platformunun güncellenmiş bir sürümünü yayınladı." },
        year2026: { title: "Kendi Oyun Operasyonlarının Başlatılması", desc: "SoftMaya, teknoloji ve agregasyon hizmetlerinin yanı sıra faaliyetlerini genişleterek kendi oyun operasyonlarına başladı." }
      },
      services: {
        platform: "iGaming Platform Altyapısı",
        aggregation: "Oyun Agregasyon Çözümleri",
        localization: "Yerelleştirme & Erişim Optimizasyonu",
        payments: "Ödeme & Kripto Ödeme Sistemleri",
        campaigns: "Kampanya, Bonus & Jackpot Motorları",
        api: "Ölçeklenebilir API Entegrasyonları"
      }
    },
    slotMachine: {
      badge: "Satın Almadan Önce Deneyin",
      title1: "Oyun Teknolojimizi",
      title2: "Deneyimleyin",
      description: "Bu mini slot demosu ile platform kalitemizi test edin. Tam platformumuz",
      games: "10.000+ oyun",
      descEnd: ", sorunsuz entegrasyonlar ve kurumsal düzeyde güvenilirlik sunar.",
      requestDemo: "Tam Demo Talep Et",
      exploreGames: "10K+ Oyunu Keşfet",
      statsGames: "Mevcut Oyun",
      statsProviders: "Oyun Sağlayıcı",
      statsUptime: "Uptime"
    },
    contact: {
      title: "İletişime Geçin",
      contactTab: "Bize Ulaşın",
      demoTab: "Demo Talep Et",
      name: "Ad Soyad",
      email: "E-posta Adresi",
      company: "Şirket Adı",
      phone: "Telefon Numarası",
      message: "Mesajınız",
      services: "İlgilendiğiniz Hizmetler",
      submit: "Mesaj Gönder",
      submitDemo: "Demo Talep Et",
      success: "Mesaj başarıyla gönderildi!",
      demoSuccess: "Demo talebi gönderildi!"
    },
    footer: {
      tagline: "iGaming'in geleceğini güçlendiriyoruz",
      services: "Hizmetler",
      company: "Şirket",
      legal: "Yasal",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Şartları",
      aml: "AML Politikası",
      copyright: "© 2024 SOFTMAYA GAMING. Tüm hakları saklıdır."
    }
  },
  de: {
    nav: {
      services: "Dienstleistungen",
      about: "Über uns",
      contact: "Kontakt",
      demo: "Demo Anfordern",
      viewAllServices: "Alle Dienstleistungen"
    },
    hero: {
      title: "iGaming-Lösungen der nächsten Generation",
      subtitle: "Wir treiben die Zukunft des Online-Gamings mit nahtloser Aggregation, modernsten Plattformen und sicherer Zahlungsabwicklung voran.",
      cta: "Loslegen",
      stats: {
        games: "Spiele",
        providers: "Anbieter",
        markets: "Märkte",
        uptime: "Verfügbarkeit"
      }
    },
    services: {
      label: "Was Wir Anbieten",
      title: "Unsere Dienstleistungen",
      aggregator: {
        title: "iGaming Aggregator",
        desc: "Zugriff auf 10.000+ Spiele von 100+ Anbietern über eine einzige API-Integration."
      },
      platform: {
        title: "iGaming Platform",
        desc: "Schlüsselfertige White-Label-Lösungen mit vollständiger Anpassung und schneller Bereitstellung."
      },
      payments: {
        title: "iGaming Payments",
        desc: "Multi-Währungs-Zahlungsabwicklung mit 99,9% Verfügbarkeitsgarantie."
      },
      crypto: {
        title: "Crypto Payments",
        desc: "Akzeptieren Sie BTC, ETH, USDT und 50+ Kryptowährungen sofort."
      }
    },
    about: {
      label: "Über Uns",
      title: "Über SoftMaya",
      description1: "SoftMaya wurde 2016 gegründet und hat sich zu einem führenden Technologieanbieter in der iGaming-Branche entwickelt, der End-to-End-Lösungen für Skalierbarkeit, Leistung und globale Reichweite bietet.",
      description2: "Von Anfang an lag unser Fokus auf dem Aufbau robuster Infrastruktur und der Vereinfachung komplexer Operationen für Betreiber. Im Laufe der Jahre haben wir unser Ökosystem kontinuierlich erweitert und uns an Branchenanforderungen und technologische Entwicklungen angepasst.",
      ourJourney: "Unsere Reise",
      today: "Heute",
      todayDesc: "SoftMaya ist ein umfassender Technologiepartner für iGaming-Unternehmen und bietet:",
      todayFooter: "Unsere Lösungen sind darauf ausgelegt, nahtlose Benutzererfahrungen, operative Effizienz und die Flexibilität zu bieten, die für den Betrieb in mehreren Jurisdiktionen erforderlich ist.",
      ourVision: "Unsere Vision",
      visionDesc: "Die nächste Generation der iGaming-Infrastruktur aufzubauen, indem wir innovative, zuverlässige und zukunftssichere Technologielösungen liefern, die Betreiber weltweit stärken.",
      milestones: {
        year2016: { title: "Spieleaggregation", desc: "SoftMaya wurde mit starkem Fokus auf Spieleaggregation gegründet und bietet Betreibern nahtlosen Zugang zu mehreren Spieleanbietern über eine einzige Integration." },
        year2019: { title: "iGaming-Plattformlösungen", desc: "Wir führten unsere vollständige iGaming-Plattform ein, die eine komplette Betriebsumgebung einschließlich Spielerverwaltung, Back-Office-Tools und skalierbarer Systemarchitektur bietet." },
        year2020: { title: "iGaming-Zahlungslösungen", desc: "Wir entwickelten fortschrittliche Zahlungslösungen speziell für den iGaming-Sektor, die schnelle, sichere und lokalisierte Transaktionen in verschiedenen Märkten ermöglichen." },
        year2022: { title: "Krypto-Zahlungslösungen", desc: "Mit der Expansion in digitale Finanzen integrierten wir Krypto-Zahlungssysteme, die es Betreibern ermöglichen, moderne Zahlungsmethoden mit hoher Effizienz und Flexibilität zu unterstützen." },
        year2023: { title: "Kampagnen-, Promotion- & Jackpot-Systeme", desc: "Wir lancierten fortschrittliche Engagement-Tools, einschließlich Kampagnenmanagement-Systeme, Promotion-Engines und dynamische Jackpot-Lösungen zur Verbesserung der Spielerbindung und Monetarisierung." },
        year2024: { title: "Neue Anbieterpartnerschaften", desc: "SoftMaya erweiterte sein Spielaggregationsportfolio durch neue Vereinbarungen mit Spieleanbietern." },
        year2025: { title: "Upgrade der Gaming-Plattform", desc: "SoftMaya veröffentlichte eine aktualisierte Version seiner Gaming-Plattform." },
        year2026: { title: "Start eigener Gaming-Aktivitäten", desc: "SoftMaya nahm eigene Gaming-Aktivitäten auf und erweiterte damit seine Tätigkeit neben seinen Technologie- und Aggregationsdienstleistungen." }
      },
      services: {
        platform: "iGaming-Plattforminfrastruktur",
        aggregation: "Spieleaggregationslösungen",
        localization: "Lokalisierung & Zugriffsoptimierung",
        payments: "Zahlungs- & Krypto-Zahlungssysteme",
        campaigns: "Kampagnen-, Bonus- & Jackpot-Engines",
        api: "API-gesteuerte Integrationen für skalierbare Operationen"
      }
    },
    slotMachine: {
      badge: "Vor dem Kauf testen",
      title1: "Erleben Sie Unsere",
      title2: "Spieletechnologie",
      description: "Testen Sie unsere Plattformqualität mit dieser Mini-Slot-Demo. Unsere vollständige Plattform bietet",
      games: "10.000+ Spiele",
      descEnd: ", nahtlose Integrationen und Enterprise-Zuverlässigkeit.",
      requestDemo: "Vollständige Demo Anfordern",
      exploreGames: "10K+ Spiele Erkunden",
      statsGames: "Verfügbare Spiele",
      statsProviders: "Spieleanbieter",
      statsUptime: "Verfügbarkeit"
    },
    contact: {
      title: "Kontaktieren Sie uns",
      contactTab: "Kontakt",
      demoTab: "Demo Anfordern",
      name: "Vollständiger Name",
      email: "E-Mail-Adresse",
      company: "Firmenname",
      phone: "Telefonnummer",
      message: "Ihre Nachricht",
      services: "Interessierte Dienstleistungen",
      submit: "Nachricht Senden",
      submitDemo: "Demo Anfordern",
      success: "Nachricht erfolgreich gesendet!",
      demoSuccess: "Demo-Anfrage eingereicht!"
    },
    footer: {
      tagline: "Die Zukunft des iGaming antreiben",
      services: "Dienstleistungen",
      company: "Unternehmen",
      legal: "Rechtliches",
      privacy: "Datenschutzrichtlinie",
      terms: "Nutzungsbedingungen",
      aml: "AML-Richtlinie",
      copyright: "© 2024 SOFTMAYA GAMING. Alle Rechte vorbehalten."
    }
  },
  fr: {
    nav: {
      services: "Services",
      about: "À propos",
      contact: "Contact",
      demo: "Demander une Démo",
      viewAllServices: "Voir Tous les Services"
    },
    hero: {
      title: "Solutions iGaming Nouvelle Génération",
      subtitle: "Propulser l'avenir du jeu en ligne avec une agrégation transparente, des plateformes de pointe et un traitement sécurisé des paiements.",
      cta: "Commencer",
      stats: {
        games: "Jeux",
        providers: "Fournisseurs",
        markets: "Marchés",
        uptime: "Disponibilité"
      }
    },
    services: {
      label: "Ce Que Nous Offrons",
      title: "Nos Services",
      aggregator: {
        title: "iGaming Aggregator",
        desc: "Accédez à 10 000+ jeux de 100+ fournisseurs via une seule intégration API."
      },
      platform: {
        title: "iGaming Platform",
        desc: "Solutions clé en main en marque blanche avec personnalisation complète et déploiement rapide."
      },
      payments: {
        title: "iGaming Payments",
        desc: "Traitement des paiements multi-devises avec garantie de disponibilité de 99,9%."
      },
      crypto: {
        title: "Crypto Payments",
        desc: "Acceptez BTC, ETH, USDT et 50+ crypto-monnaies instantanément."
      }
    },
    about: {
      label: "À Propos",
      title: "À Propos de SoftMaya",
      description1: "Fondée en 2016, SoftMaya est devenue un fournisseur de technologie de premier plan dans l'industrie iGaming, offrant des solutions de bout en bout conçues pour l'évolutivité, la performance et la portée mondiale.",
      description2: "Dès le début, notre objectif a été de construire une infrastructure robuste et de simplifier les opérations complexes pour les opérateurs. Au fil des années, nous avons continuellement élargi notre écosystème, en nous adaptant aux demandes de l'industrie et aux avancées technologiques.",
      ourJourney: "Notre Parcours",
      today: "Aujourd'hui",
      todayDesc: "SoftMaya opère comme un partenaire technologique complet pour les entreprises iGaming, offrant:",
      todayFooter: "Nos solutions sont conçues pour offrir des expériences utilisateur fluides, une efficacité opérationnelle et la flexibilité nécessaire pour opérer dans plusieurs juridictions.",
      ourVision: "Notre Vision",
      visionDesc: "Construire la prochaine génération d'infrastructure iGaming en fournissant des solutions technologiques innovantes, fiables et prêtes pour l'avenir qui responsabilisent les opérateurs du monde entier.",
      milestones: {
        year2016: { title: "Agrégation de Jeux", desc: "SoftMaya a été fondée avec un fort accent sur l'agrégation de jeux, offrant aux opérateurs un accès transparent à plusieurs fournisseurs de jeux via une seule intégration." },
        year2019: { title: "Solutions de Plateforme iGaming", desc: "Nous avons introduit notre plateforme iGaming complète, offrant un environnement opérationnel complet incluant la gestion des joueurs, les outils back-office et une architecture système évolutive." },
        year2020: { title: "Solutions de Paiement iGaming", desc: "Nous avons développé des solutions de paiement avancées spécialement conçues pour le secteur iGaming, permettant des transactions rapides, sécurisées et localisées sur divers marchés." },
        year2022: { title: "Solutions de Paiement Crypto", desc: "En nous étendant à la finance numérique, nous avons intégré des systèmes de paiement crypto, permettant aux opérateurs de prendre en charge les méthodes de paiement modernes avec une haute efficacité et flexibilité." },
        year2023: { title: "Systèmes de Campagne, Promotion & Jackpot", desc: "Nous avons lancé des outils d'engagement avancés, incluant des systèmes de gestion de campagnes, des moteurs promotionnels et des solutions de jackpot dynamiques pour améliorer la rétention des joueurs et la monétisation." },
        year2024: { title: "Nouveaux Partenariats Fournisseurs", desc: "SoftMaya a élargi son portefeuille d'agrégation de jeux grâce à de nouveaux accords avec des fournisseurs de jeux." },
        year2025: { title: "Mise à Niveau de la Plateforme de Jeu", desc: "SoftMaya a publié une version mise à jour de sa plateforme de jeu." },
        year2026: { title: "Lancement de Ses Propres Opérations de Jeu", desc: "SoftMaya a lancé ses propres opérations de jeu, élargissant ses activités aux côtés de ses services technologiques et d'agrégation." }
      },
      services: {
        platform: "Infrastructure de Plateforme iGaming",
        aggregation: "Solutions d'Agrégation de Jeux",
        localization: "Localisation & Technologies d'Optimisation d'Accès",
        payments: "Systèmes de Paiement & Paiement Crypto",
        campaigns: "Moteurs de Campagne, Bonus & Jackpot",
        api: "Intégrations API pour opérations évolutives"
      }
    },
    slotMachine: {
      badge: "Essayez Avant d'Acheter",
      title1: "Découvrez Notre",
      title2: "Technologie de Jeu",
      description: "Goûtez à la qualité de notre plateforme avec cette mini démo de slot. Notre plateforme complète propose",
      games: "10 000+ jeux",
      descEnd: ", des intégrations fluides et une fiabilité de niveau entreprise.",
      requestDemo: "Demander une Démo Complète",
      exploreGames: "Explorer 10K+ Jeux",
      statsGames: "Jeux Disponibles",
      statsProviders: "Fournisseurs de Jeux",
      statsUptime: "Disponibilité"
    },
    contact: {
      title: "Contactez-nous",
      contactTab: "Nous Contacter",
      demoTab: "Demander une Démo",
      name: "Nom Complet",
      email: "Adresse Email",
      company: "Nom de l'Entreprise",
      phone: "Numéro de Téléphone",
      message: "Votre Message",
      services: "Services d'Intérêt",
      submit: "Envoyer le Message",
      submitDemo: "Demander une Démo",
      success: "Message envoyé avec succès!",
      demoSuccess: "Demande de démo soumise!"
    },
    footer: {
      tagline: "Propulser l'avenir de l'iGaming",
      services: "Services",
      company: "Entreprise",
      legal: "Légal",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation",
      aml: "Politique AML",
      copyright: "© 2024 SOFTMAYA GAMING. Tous droits réservés."
    }
  },
  es: {
    nav: {
      services: "Servicios",
      about: "Nosotros",
      contact: "Contacto",
      demo: "Solicitar Demo",
      viewAllServices: "Ver Todos los Servicios"
    },
    hero: {
      title: "Soluciones iGaming de Nueva Generación",
      subtitle: "Impulsando el futuro del juego en línea con agregación perfecta, plataformas de vanguardia y procesamiento seguro de pagos.",
      cta: "Comenzar",
      stats: {
        games: "Juegos",
        providers: "Proveedores",
        markets: "Mercados",
        uptime: "Disponibilidad"
      }
    },
    services: {
      label: "Lo Que Ofrecemos",
      title: "Nuestros Servicios",
      aggregator: {
        title: "iGaming Aggregator",
        desc: "Accede a 10,000+ juegos de 100+ proveedores a través de una sola integración API."
      },
      platform: {
        title: "iGaming Platform",
        desc: "Soluciones llave en mano de marca blanca con personalización completa y despliegue rápido."
      },
      payments: {
        title: "iGaming Payments",
        desc: "Procesamiento de pagos multi-moneda con garantía de disponibilidad del 99.9%."
      },
      crypto: {
        title: "Crypto Payments",
        desc: "Acepta BTC, ETH, USDT y 50+ criptomonedas instantáneamente."
      }
    },
    about: {
      label: "Nosotros",
      title: "Sobre SoftMaya",
      description1: "Fundada en 2016, SoftMaya se ha convertido en un proveedor de tecnología líder en la industria iGaming, ofreciendo soluciones integrales diseñadas para escalabilidad, rendimiento y alcance global.",
      description2: "Desde el principio, nuestro enfoque ha sido construir infraestructura robusta y simplificar operaciones complejas para los operadores. A lo largo de los años, hemos expandido continuamente nuestro ecosistema, adaptándonos a las demandas de la industria y los avances tecnológicos.",
      ourJourney: "Nuestro Recorrido",
      today: "Hoy",
      todayDesc: "SoftMaya opera como un socio tecnológico integral para empresas iGaming, ofreciendo:",
      todayFooter: "Nuestras soluciones están diseñadas para proporcionar experiencias de usuario fluidas, eficiencia operativa y la flexibilidad requerida para operar en múltiples jurisdicciones.",
      ourVision: "Nuestra Visión",
      visionDesc: "Construir la próxima generación de infraestructura iGaming entregando soluciones tecnológicas innovadoras, confiables y preparadas para el futuro que empoderen a operadores en todo el mundo.",
      milestones: {
        year2016: { title: "Agregación de Juegos", desc: "SoftMaya fue establecida con un fuerte enfoque en agregación de juegos, proporcionando a los operadores acceso fluido a múltiples proveedores de juegos a través de una sola integración." },
        year2019: { title: "Soluciones de Plataforma iGaming", desc: "Introdujimos nuestra plataforma iGaming completa, ofreciendo un entorno operativo completo que incluye gestión de jugadores, herramientas de back-office y arquitectura de sistema escalable." },
        year2020: { title: "Soluciones de Pago iGaming", desc: "Desarrollamos soluciones de pago avanzadas diseñadas específicamente para el sector iGaming, permitiendo transacciones rápidas, seguras y localizadas en varios mercados." },
        year2022: { title: "Soluciones de Pago Crypto", desc: "Expandiéndonos a finanzas digitales, integramos sistemas de pago crypto, permitiendo a los operadores soportar métodos de pago modernos con alta eficiencia y flexibilidad." },
        year2023: { title: "Sistemas de Campaña, Promoción y Jackpot", desc: "Lanzamos herramientas de engagement avanzadas, incluyendo sistemas de gestión de campañas, motores promocionales y soluciones de jackpot dinámicas para mejorar la retención de jugadores y monetización." },
        year2024: { title: "Nuevas Alianzas con Proveedores", desc: "SoftMaya amplió su cartera de agregación de juegos mediante nuevos acuerdos con proveedores de juegos." },
        year2025: { title: "Actualización de la Plataforma de Juego", desc: "SoftMaya lanzó una versión actualizada de su plataforma de juego." },
        year2026: { title: "Lanzamiento de Operaciones de Juego Propias", desc: "SoftMaya inició sus propias operaciones de juego, ampliando sus actividades junto a sus servicios de tecnología y agregación." }
      },
      services: {
        platform: "Infraestructura de Plataforma iGaming",
        aggregation: "Soluciones de Agregación de Juegos",
        localization: "Localización y Tecnologías de Optimización de Acceso",
        payments: "Sistemas de Pago y Pago Crypto",
        campaigns: "Motores de Campaña, Bonus y Jackpot",
        api: "Integraciones API para operaciones escalables"
      }
    },
    slotMachine: {
      badge: "Prueba Antes de Comprar",
      title1: "Experimenta Nuestra",
      title2: "Tecnología de Juegos",
      description: "Prueba la calidad de nuestra plataforma con esta mini demo de slot. Nuestra plataforma completa incluye",
      games: "10.000+ juegos",
      descEnd: ", integraciones fluidas y confiabilidad de nivel empresarial.",
      requestDemo: "Solicitar Demo Completa",
      exploreGames: "Explorar 10K+ Juegos",
      statsGames: "Juegos Disponibles",
      statsProviders: "Proveedores de Juegos",
      statsUptime: "Disponibilidad"
    },
    contact: {
      title: "Contáctanos",
      contactTab: "Contacto",
      demoTab: "Solicitar Demo",
      name: "Nombre Completo",
      email: "Correo Electrónico",
      company: "Nombre de la Empresa",
      phone: "Número de Teléfono",
      message: "Tu Mensaje",
      services: "Servicios de Interés",
      submit: "Enviar Mensaje",
      submitDemo: "Solicitar Demo",
      success: "¡Mensaje enviado con éxito!",
      demoSuccess: "¡Solicitud de demo enviada!"
    },
    footer: {
      tagline: "Impulsando el futuro del iGaming",
      services: "Servicios",
      company: "Empresa",
      legal: "Legal",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      aml: "Política AML",
      copyright: "© 2024 SOFTMAYA GAMING. Todos los derechos reservados."
    }
  },
  ru: {
    nav: {
      services: "Услуги",
      about: "О нас",
      contact: "Контакты",
      demo: "Запросить Демо",
      viewAllServices: "Все Услуги"
    },
    hero: {
      title: "iGaming Решения Нового Поколения",
      subtitle: "Мы создаём будущее онлайн-гейминга с бесшовной агрегацией, передовыми платформами и безопасной обработкой платежей.",
      cta: "Начать",
      stats: {
        games: "Игр",
        providers: "Провайдеров",
        markets: "Рынков",
        uptime: "Аптайм"
      }
    },
    services: {
      label: "Что Мы Предлагаем",
      title: "Наши Услуги",
      aggregator: {
        title: "iGaming Aggregator",
        desc: "Доступ к 10,000+ играм от 100+ провайдеров через единую API интеграцию."
      },
      platform: {
        title: "iGaming Platform",
        desc: "Готовые решения white-label с полной кастомизацией и быстрым развёртыванием."
      },
      payments: {
        title: "iGaming Payments",
        desc: "Мультивалютная обработка платежей с гарантией 99.9% аптайма."
      },
      crypto: {
        title: "Crypto Payments",
        desc: "Принимайте BTC, ETH, USDT и 50+ криптовалют мгновенно."
      }
    },
    about: {
      label: "О Нас",
      title: "О SoftMaya",
      description1: "Основанная в 2016 году, SoftMaya стала ведущим поставщиком технологий в индустрии iGaming, предоставляя комплексные решения, разработанные для масштабируемости, производительности и глобального охвата.",
      description2: "С самого начала наш фокус был направлен на создание надежной инфраструктуры и упрощение сложных операций для операторов. На протяжении многих лет мы постоянно расширяли нашу экосистему, адаптируясь к требованиям индустрии и технологическим достижениям.",
      ourJourney: "Наш Путь",
      today: "Сегодня",
      todayDesc: "SoftMaya работает как комплексный технологический партнер для iGaming-бизнеса, предлагая:",
      todayFooter: "Наши решения разработаны для обеспечения бесшовного пользовательского опыта, операционной эффективности и гибкости, необходимой для работы в нескольких юрисдикциях.",
      ourVision: "Наше Видение",
      visionDesc: "Создавать инфраструктуру iGaming нового поколения, предоставляя инновационные, надежные и готовые к будущему технологические решения, которые расширяют возможности операторов по всему миру.",
      milestones: {
        year2016: { title: "Агрегация Игр", desc: "SoftMaya была основана с сильным фокусом на агрегацию игр, предоставляя операторам беспрепятственный доступ к нескольким игровым провайдерам через единую интеграцию." },
        year2019: { title: "Решения iGaming Платформы", desc: "Мы представили нашу полную iGaming-платформу, предлагающую полноценную операционную среду, включая управление игроками, инструменты бэк-офиса и масштабируемую системную архитектуру." },
        year2020: { title: "Платежные Решения iGaming", desc: "Мы разработали передовые платежные решения, специально созданные для сектора iGaming, обеспечивающие быстрые, безопасные и локализованные транзакции на различных рынках." },
        year2022: { title: "Крипто Платежные Решения", desc: "Расширяясь в цифровые финансы, мы интегрировали криптоплатежные системы, позволяющие операторам поддерживать современные методы оплаты с высокой эффективностью и гибкостью." },
        year2023: { title: "Системы Кампаний, Промоакций и Джекпотов", desc: "Мы запустили передовые инструменты вовлечения, включая системы управления кампаниями, промо-движки и динамические джекпот-решения для улучшения удержания игроков и монетизации." },
        year2024: { title: "Новые Партнёрства с Провайдерами", desc: "SoftMaya расширила свой портфель агрегации игр благодаря новым соглашениям с игровыми провайдерами." },
        year2025: { title: "Обновление Игровой Платформы", desc: "SoftMaya выпустила обновлённую версию своей игровой платформы." },
        year2026: { title: "Запуск Собственных Игровых Операций", desc: "SoftMaya начала собственные игровые операции, расширив свою деятельность наряду с технологическими услугами и услугами агрегации." }
      },
      services: {
        platform: "Инфраструктура iGaming Платформы",
        aggregation: "Решения для Агрегации Игр",
        localization: "Локализация и Технологии Оптимизации Доступа",
        payments: "Платежные и Крипто-Платежные Системы",
        campaigns: "Движки Кампаний, Бонусов и Джекпотов",
        api: "API-интеграции для масштабируемых операций"
      }
    },
    slotMachine: {
      badge: "Попробуйте Перед Покупкой",
      title1: "Испытайте Нашу",
      title2: "Игровую Технологию",
      description: "Оцените качество нашей платформы с этой мини-слот демо. Наша полная платформа включает",
      games: "10 000+ игр",
      descEnd: ", бесшовные интеграции и надежность корпоративного уровня.",
      requestDemo: "Запросить Полную Демо",
      exploreGames: "Исследовать 10K+ Игр",
      statsGames: "Доступно Игр",
      statsProviders: "Провайдеров Игр",
      statsUptime: "Время Работы"
    },
    contact: {
      title: "Свяжитесь с Нами",
      contactTab: "Связаться",
      demoTab: "Запросить Демо",
      name: "Полное Имя",
      email: "Email Адрес",
      company: "Название Компании",
      phone: "Номер Телефона",
      message: "Ваше Сообщение",
      services: "Интересующие Услуги",
      submit: "Отправить Сообщение",
      submitDemo: "Запросить Демо",
      success: "Сообщение успешно отправлено!",
      demoSuccess: "Заявка на демо отправлена!"
    },
    footer: {
      tagline: "Создаём будущее iGaming",
      services: "Услуги",
      company: "Компания",
      legal: "Юридическая информация",
      privacy: "Политика Конфиденциальности",
      terms: "Условия Использования",
      aml: "AML Политика",
      copyright: "© 2024 SOFTMAYA GAMING. Все права защищены."
    }
  },
  el: {
    nav: {
      services: "Υπηρεσίες",
      about: "Σχετικά",
      contact: "Επικοινωνία",
      demo: "Ζητήστε Demo",
      viewAllServices: "Όλες οι Υπηρεσίες"
    },
    hero: {
      title: "Λύσεις iGaming Νέας Γενιάς",
      subtitle: "Ενισχύουμε το μέλλον του online gaming με απρόσκοπτη συγκέντρωση, πλατφόρμες αιχμής και ασφαλή επεξεργασία πληρωμών.",
      cta: "Ξεκινήστε",
      stats: {
        games: "Παιχνίδια",
        providers: "Πάροχοι",
        markets: "Αγορές",
        uptime: "Διαθεσιμότητα"
      }
    },
    services: {
      label: "Τι Προσφέρουμε",
      title: "Οι Υπηρεσίες μας",
      aggregator: {
        title: "iGaming Aggregator",
        desc: "Πρόσβαση σε 10.000+ παιχνίδια από 100+ παρόχους μέσω ενός μόνο API."
      },
      platform: {
        title: "iGaming Platform",
        desc: "Λύσεις white-label με πλήρη προσαρμογή και γρήγορη ανάπτυξη."
      },
      payments: {
        title: "iGaming Payments",
        desc: "Επεξεργασία πληρωμών πολλαπλών νομισμάτων με εγγύηση 99,9% uptime."
      },
      crypto: {
        title: "Crypto Payments",
        desc: "Αποδεχτείτε BTC, ETH, USDT και 50+ κρυπτονομίσματα άμεσα."
      }
    },
    about: {
      label: "Σχετικά με Εμάς",
      title: "Σχετικά με τη SoftMaya",
      description1: "Ιδρυμένη το 2016, η SoftMaya έχει εξελιχθεί σε κορυφαίο πάροχο τεχνολογίας στη βιομηχανία iGaming, προσφέροντας ολοκληρωμένες λύσεις σχεδιασμένες για επεκτασιμότητα, απόδοση και παγκόσμια εμβέλεια.",
      description2: "Από την αρχή, η εστίασή μας ήταν η δημιουργία ισχυρής υποδομής και η απλοποίηση πολύπλοκων λειτουργιών για τους φορείς εκμετάλλευσης. Με τα χρόνια, έχουμε συνεχώς επεκτείνει το οικοσύστημά μας, προσαρμοζόμενοι στις απαιτήσεις της βιομηχανίας και τις τεχνολογικές εξελίξεις.",
      ourJourney: "Η Πορεία μας",
      today: "Σήμερα",
      todayDesc: "Η SoftMaya λειτουργεί ως ολοκληρωμένος τεχνολογικός συνεργάτης για επιχειρήσεις iGaming, προσφέροντας:",
      todayFooter: "Οι λύσεις μας είναι σχεδιασμένες να παρέχουν απρόσκοπτες εμπειρίες χρήστη, λειτουργική αποδοτικότητα και την ευελιξία που απαιτείται για λειτουργία σε πολλαπλές δικαιοδοσίες.",
      ourVision: "Το Όραμά μας",
      visionDesc: "Να χτίσουμε την επόμενη γενιά υποδομής iGaming παρέχοντας καινοτόμες, αξιόπιστες και έτοιμες για το μέλλον τεχνολογικές λύσεις που ενδυναμώνουν φορείς εκμετάλλευσης παγκοσμίως.",
      milestones: {
        year2016: { title: "Συγκέντρωση Παιχνιδιών", desc: "Η SoftMaya ιδρύθηκε με ισχυρή εστίαση στη συγκέντρωση παιχνιδιών, παρέχοντας στους φορείς απρόσκοπτη πρόσβαση σε πολλαπλούς παρόχους παιχνιδιών μέσω μιας ενιαίας ενσωμάτωσης." },
        year2019: { title: "Λύσεις Πλατφόρμας iGaming", desc: "Εισαγάγαμε την πλήρη πλατφόρμα iGaming μας, προσφέροντας ένα ολοκληρωμένο λειτουργικό περιβάλλον που περιλαμβάνει διαχείριση παικτών, εργαλεία back-office και επεκτάσιμη αρχιτεκτονική συστήματος." },
        year2020: { title: "Λύσεις Πληρωμών iGaming", desc: "Αναπτύξαμε προηγμένες λύσεις πληρωμών ειδικά σχεδιασμένες για τον τομέα iGaming, επιτρέποντας γρήγορες, ασφαλείς και τοπικοποιημένες συναλλαγές σε διάφορες αγορές." },
        year2022: { title: "Λύσεις Κρυπτο-Πληρωμών", desc: "Επεκτεινόμενοι στα ψηφιακά χρηματοοικονομικά, ενσωματώσαμε συστήματα κρυπτο-πληρωμών, επιτρέποντας στους φορείς να υποστηρίζουν σύγχρονες μεθόδους πληρωμής με υψηλή αποδοτικότητα και ευελιξία." },
        year2023: { title: "Συστήματα Καμπανιών, Προσφορών & Jackpot", desc: "Λανσάραμε προηγμένα εργαλεία εμπλοκής, συμπεριλαμβανομένων συστημάτων διαχείρισης καμπανιών, μηχανών προσφορών και δυναμικών λύσεων jackpot για τη βελτίωση της διατήρησης παικτών και της νομισματοποίησης." },
        year2024: { title: "Νέες Συνεργασίες με Παρόχους", desc: "Η SoftMaya επέκτεινε το χαρτοφυλάκιο συνάθροισης παιχνιδιών της μέσω νέων συμφωνιών με παρόχους παιχνιδιών." },
        year2025: { title: "Αναβάθμιση της Πλατφόρμας Παιχνιδιών", desc: "Η SoftMaya κυκλοφόρησε μια ενημερωμένη έκδοση της πλατφόρμας παιχνιδιών της." },
        year2026: { title: "Έναρξη Ιδίων Δραστηριοτήτων Gaming", desc: "Η SoftMaya ξεκίνησε τις δικές της δραστηριότητες gaming, επεκτείνοντας τις δραστηριότητές της παράλληλα με τις υπηρεσίες τεχνολογίας και συνάθροισης." }
      },
      services: {
        platform: "Υποδομή Πλατφόρμας iGaming",
        aggregation: "Λύσεις Συγκέντρωσης Παιχνιδιών",
        localization: "Τοπικοποίηση & Τεχνολογίες Βελτιστοποίησης Πρόσβασης",
        payments: "Συστήματα Πληρωμών & Κρυπτο-Πληρωμών",
        campaigns: "Μηχανές Καμπανιών, Bonus & Jackpot",
        api: "Ενσωματώσεις API για επεκτάσιμες λειτουργίες"
      }
    },
    slotMachine: {
      badge: "Δοκιμάστε Πριν Αγοράσετε",
      title1: "Ζήστε την",
      title2: "Τεχνολογία Παιχνιδιών μας",
      description: "Δοκιμάστε την ποιότητα της πλατφόρμας μας με αυτή τη μίνι slot demo. Η πλήρης πλατφόρμα μας διαθέτει",
      games: "10.000+ παιχνίδια",
      descEnd: ", απρόσκοπτες ενσωματώσεις και αξιοπιστία επιχειρηματικού επιπέδου.",
      requestDemo: "Ζητήστε Πλήρες Demo",
      exploreGames: "Εξερευνήστε 10K+ Παιχνίδια",
      statsGames: "Διαθέσιμα Παιχνίδια",
      statsProviders: "Πάροχοι Παιχνιδιών",
      statsUptime: "Διαθεσιμότητα"
    },
    contact: {
      title: "Επικοινωνήστε μαζί μας",
      contactTab: "Επικοινωνία",
      demoTab: "Ζητήστε Demo",
      name: "Πλήρες Όνομα",
      email: "Διεύθυνση Email",
      company: "Όνομα Εταιρείας",
      phone: "Αριθμός Τηλεφώνου",
      message: "Το Μήνυμά σας",
      services: "Υπηρεσίες Ενδιαφέροντος",
      submit: "Αποστολή Μηνύματος",
      submitDemo: "Ζητήστε Demo",
      success: "Το μήνυμα στάλθηκε επιτυχώς!",
      demoSuccess: "Το αίτημα demo υποβλήθηκε!"
    },
    footer: {
      tagline: "Ενισχύουμε το μέλλον του iGaming",
      services: "Υπηρεσίες",
      company: "Εταιρεία",
      legal: "Νομικά",
      privacy: "Πολιτική Απορρήτου",
      terms: "Όροι Χρήσης",
      aml: "Πολιτική AML",
      copyright: "© 2024 SOFTMAYA GAMING. Με επιφύλαξη παντός δικαιώματος."
    }
  }
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'el', name: 'Ελληνικά', flag: '🇬🇷' }
];
